/**
 * The page loader, whichever layout the page is under.
 *
 * The two layouts ship the same loader with different ids and different
 * mechanics. frontend/layouts/main.blade.php calls it #loader, shows it with
 * inline styles and hides it with a CSS animation, and disposes and re-initialises
 * the ECharts instance each time. frontend/layouts/app.blade.php calls it #loader2
 * and toggles .fade-out, having initialised ECharts once on page load.
 *
 * A page has no idea which layout it is under, so callers say showLoader() and the
 * difference is resolved here. Adding a second pair of functions for the second
 * layout only pushes that decision back onto every call site.
 *
 * The layouts agreeing on one id and one mechanic is the real fix and reaches far
 * past registration. When that happens, this file is the only thing to change.
 */

function element() {
    return document.getElementById('loader') || document.getElementById('loader2');
}

/**
 * The animated loader is an ECharts instance in #echart-loader. Under main it is
 * rebuilt on every show, so a stale instance has to go first or the canvas draws
 * over itself.
 */
function resetChart() {
    const chart = document.getElementById('echart-loader');

    if (chart && typeof echarts !== 'undefined') {
        echarts.getInstanceByDom(chart)?.dispose();
    }
}

export function showLoader() {
    const el = element();

    if (! el) {
        return;
    }

    if (el.id === 'loader2') {
        el.classList.remove('fade-out');
        return;
    }

    $(el).css({
        animation: 'none',
        opacity: '1',
        visibility: 'visible',
        display: 'flex'
    });

    resetChart();

    // Defined by the page that draws the loader markup, not by this bundle, so it
    // is absent on any page that never shows one.
    if (typeof initEChartsLoader === 'function') {
        setTimeout(() => initEChartsLoader(), 50);
    }
}

export function hideLoader() {
    const el = element();

    if (! el) {
        return;
    }

    if (el.id === 'loader2') {
        el.classList.add('fade-out');
        return;
    }

    resetChart();

    const $loader = $(el);

    $loader.css({
        animation: 'hideLoader 0.5s forwards',
        display: 'flex'
    });

    setTimeout(() => $loader.hide(), 500);
}
